<template>
	<b-modal ref="profile_modal"
			 size="lg"
			 bodyClass="p-0"
			 v-bind:no-close-on-backdrop=true
			 :hide-header=true
			 v-model="is_show_modal"
			 :dialogClass=dialog_class_draw>

		<template v-slot:modal-header="{ close }">
			<!-- Emulate built in modal header close button action -->
			<b-button size="sm" variant="outline-danger" @click="close()">
				Close Modal
			</b-button>
		</template>

		<!-- BODY -->
		<div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
			<div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
				<h2 v-if="question.id > 0">
					<span class="fw-300">ID:{{this.question.id}} | {{this.question.title}}</span>
				</h2>

				<h2 v-else>
					Створення питання
				</h2>

				<div class="panel-toolbar pr-3 pb-2 align-self-end">
					<button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
						<i class="fal fa-times"></i>
					</button>
				</div>
			</div>

			<div class="panel-container show">
				<b-overlay :show="is_load" rounded="sm">
					<div class="panel-content">
						<div class="d-flex flex-column align-items-center justify-content-center p-4">
							<h5 class="mb-0 fw-700 text-center mt-3" v-if="question.id > 0">
								{{this.question.id}}
							</h5>

							<h6>
								{{this.question.title}}
							</h6>
						</div>

						<div>
							<b-tabs content-class="mt-3">
								<b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
									   :disabled="tab.disabled"
									   :title="get_tab_title(tab)"
									   :key="index"
									   :active="tab.is_active"
								>
									<template slot="title">
										{{get_tab_title(tab)}}
										<b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
									</template>

									<component v-bind:is="tab.index" :question="question"></component>
								</b-tab>
							</b-tabs>
						</div>
					</div>
				</b-overlay>
			</div>
			<!--FOOTER -->
		</div>

		<template v-slot:modal-footer="{close}">
			<div class="modal-footer">
				<button type="button" v-on:click="close_mod" class="btn btn-secondary waves-effect waves-themed">
					Закрити
				</button>

				<button type="button" v-on:click="save_it" class="btn btn-success waves-effect waves-themed">
					Зберегти
				</button>

			</div>
		</template>
	</b-modal>
</template>

<script>
import checklist_info from "./tabs/checklist_info";
import checklist_answers from "./tabs/checklist_answers";

export default {
	name: "edit_sbquest",
	components : {
		checklist_info,
		checklist_answers
	},
	data() {
		return  {
			is_show_modal : false,
			is_load_adv : false,
			is_load : false,
			question: {
				id : 0,
				title : "",
				type : "in",
				owner_type :"own",
				tmz_type : "in_tmz",
				owner_id : 0,
				answers : [],
                tips_ids : [],
			},
   
			tabs:[
                {
					title: "Основні",
					index : "checklist_info"
				},

				{
					title: "Варіанти відповідей",
					index : "checklist_answers"
				},
			]
		}
	},

	created() {
		EventBus.$on("edit_sb_quest",res => this.work_click(res));
		EventBus.$on("remove_sb_question",res => this.remove(res));
	},


	methods : {
		close_mod() {
			this.close();
		},

		close() {
			this.question = this.default_quest;
		//	this.tabs = [];
			this.is_show_modal = false;

		},
		get_tab_title (tab) {
			if(tab.count > 0) {
				return tab.title;
			}
			return tab.title;
		},

		set_active (obj) {
			for (let tab in this.tabs) {
				this.tabs[tab].is_active = false;
			}

			this.tabs[obj].is_active = true;
			EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
		},

		work_click(quest_id) {
			if(quest_id > 0) {
				this.loadQuestion(quest_id);
			}
			this.is_show_modal = true;

		},
		async loadQuestion(quest_id) {
			this.is_load = true;
			this.question = this.default_quest;

            //+
			await api.get('/checkin/' + quest_id)
				.then(({data}) => {
					this.is_load = false;
					if(data.status == 'operation_success') {
						this.question = data.data;
					}

				}).catch(err => {
					this.is_load = false;
					EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
				});
		},

		async remove(id) {
			const is_ok = confirm_imc('Видалити ?');
			is_ok.then(res => {
                api.delete('/checkin/' + id).then(({data}) => {
					if (data.status == "operation_success") {
						window.location.reload();
					}
					this.is_load = false;
				}).catch(err => {
					this.is_load = false;
					EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
				});
			});
		},

		async save_it() {
			this.is_load = true;
			await api.put('/checkin/' + this.question.id +'/question_create',this.question)
				.then(({data}) => {
					this.is_load = false;
					if(data.status == 'operation_success') {
						this.question = data.data;
					}
				}).catch(err => {
					this.is_load = false;
					EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
				});
		},

	},


	computed : {
		cur_user() {
			return this.$store.state.common.imc_core_const;
		},

		default_quest () {
			return {
				id : 0,
				title : "",
				type : "in",
				owner_type :"own",
				tips_ids : [],
				answers : [],
			}
		},

		dialog_class_draw () {
			if(this.modal_position === "left") {
				return "modal-dialog-left modal-lg";
			}

			return "modal-dialog-left modal-lg";
		},

	}
}
</script>

<style scoped>

</style>
